var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralAvgcourseduration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.326,
    height: 41.435,
    viewBox: "0 0 44.326 41.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x37_5",
    transform: "translate(-2.5 -4.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48095",
    "data-name": "Group 48095",
    transform: "translate(9.511 12.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55231",
    "data-name": "Path 55231",
    d: "M47.407,17.03V36.443a4.086,4.086,0,0,1-4.086,4.086H24.715l-7.439,5.515a.668.668,0,0,1-1.066-.536V40.529H14.179a4.086,4.086,0,0,1-4.086-4.086V17.03c0-2.257,1.83-4.086,5.216-4.086H44.45c1.128,0,2.957,1.83,2.957,4.086Z",
    transform: "translate(-10.093 -12.943)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48098",
    "data-name": "Group 48098",
    transform: "translate(29.295 13.491)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48096",
    "data-name": "Group 48096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55232",
    "data-name": "Path 55232",
    d: "M32.959,15.746h-.707a.737.737,0,1,1,0-1.473h.707a.737.737,0,1,1,0,1.473Z",
    transform: "translate(-31.516 -14.273)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48097",
    "data-name": "Group 48097",
    transform: "translate(3.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55233",
    "data-name": "Path 55233",
    d: "M43.112,15.746H36.389a.737.737,0,1,1,0-1.473h6.723a.737.737,0,0,1,0,1.473Z",
    transform: "translate(-35.652 -14.273)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48101",
    "data-name": "Group 48101",
    transform: "translate(10.791 23.58)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48099",
    "data-name": "Group 48099",
    transform: "translate(0 3.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55234",
    "data-name": "Path 55234",
    d: "M12.214,35.163a.737.737,0,0,1-.737-.737V29.9a.737.737,0,1,1,1.473,0v4.522A.737.737,0,0,1,12.214,35.163Z",
    transform: "translate(-11.478 -29.168)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48100",
    "data-name": "Group 48100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55235",
    "data-name": "Path 55235",
    d: "M12.214,27.437a.737.737,0,0,1-.737-.737v-.766a.737.737,0,1,1,1.473,0V26.7A.737.737,0,0,1,12.214,27.437Z",
    transform: "translate(-11.478 -25.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48102",
    "data-name": "Group 48102",
    transform: "translate(15.63 12.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55236",
    "data-name": "Path 55236",
    d: "M47.914,17.059V36.474a4.085,4.085,0,0,1-4.085,4.085H25.223l-7.434,5.519a.673.673,0,0,1-1.07-.54V44.2L23.2,39.4a1.271,1.271,0,0,1,.757-.25H42.14a4.085,4.085,0,0,0,4.085-4.085V15.645a4.067,4.067,0,0,0-.717-2.308,4.068,4.068,0,0,1,2.406,3.722Z",
    transform: "translate(-16.718 -13.337)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48103",
    "data-name": "Group 48103",
    transform: "translate(13.439 16.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55237",
    "data-name": "Path 55237",
    d: "M14.346,34.449V19.675c0-1.368,1.109-2.478,3.607-2.478h23.58A2.505,2.505,0,0,1,43.8,19.675V34.449a2.478,2.478,0,0,1-2.478,2.478h-24.5a2.478,2.478,0,0,1-2.478-2.478Z",
    transform: "translate(-14.346 -17.197)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48104",
    "data-name": "Group 48104",
    transform: "translate(13.548 16.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55238",
    "data-name": "Path 55238",
    d: "M43.813,19.68V34.45a2.471,2.471,0,0,1-2.475,2.475H16.83A2.476,2.476,0,0,1,14.463,35.2a2.373,2.373,0,0,0,.462.039h24.5A2.479,2.479,0,0,0,41.9,32.751V17.981a2.691,2.691,0,0,0-.108-.746,2.489,2.489,0,0,1,2.023,2.445Z",
    transform: "translate(-14.463 -17.234)",
    fill: "#e4e3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48105",
    "data-name": "Group 48105",
    transform: "translate(21.806 18.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55239",
    "data-name": "Path 55239",
    d: "M36.132,26.577a6.363,6.363,0,1,1-6.368-6.368A6.362,6.362,0,0,1,36.132,26.577Z",
    transform: "translate(-23.406 -20.209)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48107",
    "data-name": "Group 48107",
    transform: "translate(23.067 21.132)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48106",
    "data-name": "Group 48106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55240",
    "data-name": "Path 55240",
    d: "M25.167,26.976h-.014a.4.4,0,0,1-.38-.409,5.09,5.09,0,0,1,2.087-3.942.4.4,0,1,1,.468.637A4.307,4.307,0,0,0,25.562,26.6a.4.4,0,0,1-.395.38Z",
    transform: "translate(-24.772 -22.547)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48109",
    "data-name": "Group 48109",
    transform: "translate(26.775 20.228)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48108",
    "data-name": "Group 48108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55241",
    "data-name": "Path 55241",
    d: "M28.8,22.148a.4.4,0,0,1,.305-.469,5.193,5.193,0,0,1,.954-.111c.211.044.4.167.4.385a.394.394,0,0,1-.385.4,4.532,4.532,0,0,0-.811.1.4.4,0,0,1-.469-.305Z",
    transform: "translate(-28.787 -21.568)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48110",
    "data-name": "Group 48110",
    transform: "translate(22.983 20.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55242",
    "data-name": "Path 55242",
    d: "M36.229,26.69A6.361,6.361,0,0,1,24.68,30.368a6.36,6.36,0,0,0,9.122-8.68A6.347,6.347,0,0,1,36.229,26.69Z",
    transform: "translate(-24.68 -21.688)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48111",
    "data-name": "Group 48111",
    transform: "translate(26.274 22.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55243",
    "data-name": "Path 55243",
    d: "M32.727,27.726,29.939,29.69a1.076,1.076,0,0,1-1.7-.879V24.883a1.076,1.076,0,0,1,1.7-.879l2.788,1.964a1.076,1.076,0,0,1,0,1.759Z",
    transform: "translate(-28.244 -23.805)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48112",
    "data-name": "Group 48112",
    transform: "translate(26.283 24.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55244",
    "data-name": "Path 55244",
    d: "M32.721,27.9l-2.774,1.967a1.086,1.086,0,0,1-1.693-.694,1.035,1.035,0,0,0,1.113-.064l2.79-1.968a1.055,1.055,0,0,0,.435-1.08l.129.081a1.07,1.07,0,0,1,0,1.758Z",
    transform: "translate(-28.254 -26.057)",
    fill: "#e4e3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48113",
    "data-name": "Group 48113",
    transform: "translate(5.459 5.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55245",
    "data-name": "Path 55245",
    d: "M22.478,5.346l2.587,6.111a1.872,1.872,0,0,1-.566,2.2,28.583,28.583,0,0,0-4.911,5.069,2.3,2.3,0,0,1-2.278.963,28.507,28.507,0,0,0-7.046-.006,1.872,1.872,0,0,1-1.973-1.126L5.7,12.447Z",
    transform: "translate(-5.705 -5.346)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48114",
    "data-name": "Group 48114",
    transform: "translate(8.657 5.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55246",
    "data-name": "Path 55246",
    d: "M22.743,5.35l2.584,6.1a1.866,1.866,0,0,1-.561,2.2,28.78,28.78,0,0,0-4.91,5.073,2.327,2.327,0,0,1-2.28.965,28.7,28.7,0,0,0-7.05-.01,1.9,1.9,0,0,1-1.359-.352,2.3,2.3,0,0,0,.748.047,28.219,28.219,0,0,1,7.05.01,2.373,2.373,0,0,0,2.28-.965,28.3,28.3,0,0,1,4.91-5.073,1.866,1.866,0,0,0,.561-2.2L22.335,5.523Z",
    transform: "translate(-9.168 -5.35)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48115",
    "data-name": "Group 48115",
    transform: "translate(6.298 7.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55247",
    "data-name": "Path 55247",
    d: "M23.385,7.483l.259.611-7.187,5.492a1.336,1.336,0,0,1-.645.273L6.872,15.195l-.259-.611,8.941-1.335a1.453,1.453,0,0,0,.645-.273Z",
    transform: "translate(-6.613 -7.483)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48116",
    "data-name": "Group 48116",
    transform: "translate(9.096 17.078)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55248",
    "data-name": "Path 55248",
    d: "M10.522,19.7a.389.389,0,0,1-.51-.207l-.338-.8a.389.389,0,0,1,.716-.3l.338.8A.389.389,0,0,1,10.522,19.7Z",
    transform: "translate(-9.643 -18.157)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48118",
    "data-name": "Group 48118",
    transform: "translate(8.474 15.608)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48117",
    "data-name": "Group 48117",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55249",
    "data-name": "Path 55249",
    d: "M9.632,17.6a.389.389,0,0,1-.51-.207L9,17.105a.389.389,0,1,1,.716-.3l.122.288A.389.389,0,0,1,9.632,17.6Z",
    transform: "translate(-8.969 -16.565)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48119",
    "data-name": "Group 48119",
    transform: "translate(2.53 4.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55250",
    "data-name": "Path 55250",
    d: "M25.454,4.3l.273.646-.006,0a.324.324,0,0,1-.118.368l-9.713,7.424a1.36,1.36,0,0,1-.646.273l-12.079,1.8a.345.345,0,0,1-.372-.2l-.005-.013-.255-.6a.342.342,0,0,0,.375.2l12.079-1.8a1.526,1.526,0,0,0,.646-.273L25.345,4.71a.343.343,0,0,0,.108-.408Z",
    transform: "translate(-2.533 -4.302)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48120",
    "data-name": "Group 48120",
    transform: "translate(2.5 4.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55251",
    "data-name": "Path 55251",
    d: "M25.342,4.692l-9.711,7.421a1.41,1.41,0,0,1-.648.274L2.9,14.192a.349.349,0,0,1-.264-.623l9.706-7.417a1.41,1.41,0,0,1,.647-.274L25.079,4.07a.349.349,0,0,1,.264.623Z",
    transform: "translate(-2.5 -4.066)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48121",
    "data-name": "Group 48121",
    transform: "translate(2.506 8.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55252",
    "data-name": "Path 55252",
    d: "M4.209,18.917,2.6,15.125a1.25,1.25,0,0,1,.662-1.636L14.012,8.941a.231.231,0,1,1,.18.426L3.447,13.915a.786.786,0,0,0-.417,1.03l1.6,3.791a.231.231,0,0,1-.426.18Z",
    transform: "translate(-2.506 -8.923)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48122",
    "data-name": "Group 48122",
    transform: "translate(3.653 18.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55253",
    "data-name": "Path 55253",
    d: "M5.138,23.822l1.848-.782a.391.391,0,0,0,.159-.6l-1.5-1.951a.934.934,0,0,0-.042-.618.967.967,0,1,0-1.781.754.934.934,0,0,0,.415.461l.36,2.433a.391.391,0,0,0,.539.3Z",
    transform: "translate(-3.749 -19.281)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48123",
    "data-name": "Group 48123",
    transform: "translate(3.653 18.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55254",
    "data-name": "Path 55254",
    d: "M5.138,23.823l.377-.16a.391.391,0,0,1-.539-.3l-.322-2.176a.577.577,0,0,0-.191-.36.951.951,0,0,1-.262-.357A.967.967,0,0,1,4.537,19.3a.689.689,0,0,0-.2.057.971.971,0,0,0-.51,1.269.934.934,0,0,0,.415.461l.36,2.433a.391.391,0,0,0,.539.3Z",
    transform: "translate(-3.749 -19.303)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48124",
    "data-name": "Group 48124",
    transform: "translate(12.351 8.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55255",
    "data-name": "Path 55255",
    d: "M16.21,8.6c.152.359-.4.934-1.23,1.284s-1.636.352-1.788-.007.4-.934,1.239-1.288,1.626-.348,1.778.011Z",
    transform: "translate(-13.167 -8.332)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralAvgcourseduration);
export default __webpack_public_path__ + "static/media/university-general-avgcourseduration.8a066653922b8282f2fdad3b0b91d476.svg";
export { ForwardRef as ReactComponent };